import { Box } from '@factorialco/deprecated-design-system'

import { Option } from './_Option'

export type Option<T> = {
  value: T
  label: string
}

type Props<T> = {
  options: Option<T>[]
  selectedOptionValue?: T

  onOptionSelected: (value: T) => void
}

export const OptionsList = <T extends string>({
  options,
  selectedOptionValue,
  onOptionSelected,
}: Props<T>) => {
  return (
    <Box width="s240" paddingY="s12">
      {options.map((option) => (
        <Option
          key={option.value}
          label={option.label}
          selected={option.value === selectedOptionValue}
          onClick={() => onOptionSelected(option.value)}
        />
      ))}
    </Box>
  )
}
